import * as CookieConsent from "vanilla-cookieconsent"

const cookiePolicyDocument =
  "https://accolade.eu/files/documents/accolade_cookies_policy_102018_cs.pdf"
export default function intiCookiesConsent() {
  // Ignore cookies if on http
  if (window.location.protocol === "http:") {
    return
  }

  const lang = document.querySelector("html").getAttribute("lang")

  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {},
      marketing: {},
    },
    cookie: {
      sameSite: "None"
    },
    disablePageInteraction: true,
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "middle center",
        flipButtons: false,
        equalWeightButtons: false,
      },
      preferencesModal: {
        layout: "box",
        flipButtons: true,
        equalWeightButtons: false,
      },
    },
    language: {
      default: lang,
      translations: translationsObject(),
    },
    onFirstConsent: ({ cookie }) => {
      let logMessage = ""
      logMessage += checkAnalytics(CookieConsent.acceptedCategory("analytics"))
      logMessage += checkMarketing(CookieConsent.acceptedCategory("marketing"))
      dataLayerConsentUpdate()
      consentLog(logMessage)
    },
    onChange: () => {
      checkAnalytics(CookieConsent.acceptedCategory("analytics"))
      checkMarketing(CookieConsent.acceptedCategory("marketing"))
      dataLayerConsentUpdate()
    },
    onModalReady: ({ modalName, modal }) => {
      if (modalName === "consentModal") {
        moveButtons(modal)
      }
    },
  })

  checkAnalytics(CookieConsent.acceptedCategory("analytics"))
  checkMarketing(CookieConsent.acceptedCategory("marketing"))
}

function checkAnalytics(accepted) {
  if (accepted) {
    allowAnalytics()
    return 'allowed analytics,'
  } else {
    denyAnalytics()
    return 'denied analytics,'
  }
}

function checkMarketing(accepted) {
  if (accepted) {
    allowMarketing()
    return 'allowed marketing,'
  } else {
    denyMarketing()
    return 'denied marketing,'
  }
}

function allowAnalytics() {
  console.log("accepting analytics")
  gtag("consent", "update", {
    analytics_storage: "granted",
  })
}
function denyAnalytics() {
  console.log("denying analytics")
  gtag("consent", "update", {
    analytics_storage: "denied",
  })
}
function allowMarketing() {
  console.log("accepting marketing")
  gtag("consent", "update", {
    ad_storage: "granted",
  })
  console.log("accepting user data")
  gtag("consent", "update", {
    ad_user_data: "granted",
  })
  console.log("accepting personalization")
  gtag("consent", "update", {
    ad_personalization: "granted",
  })
}
function denyMarketing() {
  console.log("denying marketing")
  gtag("consent", "update", {
    ad_storage: "denied",
  })
  console.log("denying user data")
  gtag("consent", "update", {
    ad_user_data: "denied",
  })
  console.log("denying personalization")
  gtag("consent", "update", {
    ad_personalization: "denied",
  })
}

function consentLog(type) {
  console.log('log:', type)
  if (type) {
    const consentLogUrl = document.documentElement.dataset.consentLog
    const url = `${consentLogUrl}&log=${encodeURIComponent(type)}`;
    try {
      const response = fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      if (response.status > 300) throw Error()
    } catch (e) {
      console.error(e)
    }
  }
}

function dataLayerConsentUpdate() {
  dataLayer.push({
    event: "consentUpdated",
  })
}

function translationsObject() {
  return {
    en: {
      consentModal: {
        title: "WE VALUE YOUR PRIVACY",
        description: `We’re committed to shaping a better digital experience for you. We use essential cookies to keep our website running smoothly and to provide you with insights that matter. By accepting cookies, you’ll unlock a more personalized experience tailored to your interests.`,
        acceptAllBtn: "ACCEPT ALL",
        acceptNecessaryBtn: "REJECT",
        showPreferencesBtn: "Customize",
      },
      preferencesModal: {
        title: "Cookie preferences",
        acceptAllBtn: "ACCEPT ALL",
        acceptNecessaryBtn: "REJECT",
        savePreferencesBtn: "Save settings",
        closeIconLabel: "Close",
        sections: [
          {
            title: "Use of cookies 📢",
            description: `We use cookies to ensure the basic functions of the website and to improve your online experience. For each category, you can choose whether to log in / out whenever you want, via a link permanently located on the website. Further details regarding cookies can be found in our <a href="${cookiePolicyDocument}" target="_blank">Cookies Policy.</a>.`,
          },
          {
            title: "Essential cookies",
            description:
              "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
            linkedCategory: "necessary",
          },
          {
            title: "Analytics cookies",
            description:
              "These cookies allow the website to remember the choices you have made in the past",
            linkedCategory: "analytics",
          },
          {
            title: "Advertising and marketing cookies",
            description:
              "Marketing cookies are used to track visitors to the website. The intention is to display advertising that is relevant and interesting to the individual user and thus more valuable to publishers and third-party advertisers.",
            linkedCategory: "marketing",
          },
          {
            title: "More information",
            description: `For more information about how we handle personal information, please see our <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Privacy Policy</a>.`,
          },
        ],
      },
    },
    cs: {
      consentModal: {
        title: "VÁŽÍME SI VAŠEHO SOUKROMÍ",
        description: `Jsme odhodláni vytvářet pro vás lepší digitální zážitek. Používáme nezbytné cookies, aby náš web fungoval bez problémů a poskytoval vám relevantní informace. Přijetím cookies získáte osobnější zážitek přizpůsobený vašim zájmům.`,
        acceptAllBtn: "PŘIJMOUT VŠE",
        acceptNecessaryBtn: "ODMÍTNOUT",
        showPreferencesBtn: "Přizpůsobit",
      },
      preferencesModal: {
        title: "Nastavení cookies",
        acceptAllBtn: "PŘIJMOUT VŠE",
        acceptNecessaryBtn: "ODMÍTNOUT",
        savePreferencesBtn: "Uložit nastavení",
        closeIconLabel: "Zavřít",
        sections: [
          {
            title: "Použití cookies 📢",
            description: `Používáme cookies k zajištění základních funkcí webu a ke zlepšení vašeho online zážitku. Pro každou kategorii můžete kdykoli zvolit, zda se přihlásíte nebo odhlásíte, pomocí odkazu trvale umístěného na webu. Další podrobnosti o cookies naleznete v našem <a href="${cookiePolicyDocument}" target="_blank">Zásady používání cookies.</a>.`,
          },
          {
            title: "Nezbytné cookies",
            description:
              "Tyto cookies jsou nezbytné pro správné fungování mého webu. Bez těchto cookies by web nefungoval správně.",
            linkedCategory: "nezbytné",
          },
          {
            title: "Analytické cookies",
            description:
              "Tyto cookies umožňují webu si pamatovat volby, které jste učinili v minulosti.",
            linkedCategory: "analytické",
          },
          {
            title: "Reklamní a marketingové cookies",
            description:
              "Marketingové cookies se používají ke sledování návštěvníků webu. Účelem je zobrazovat reklamy, které jsou pro konkrétního uživatele relevantní a zajímavé, a tím cennější pro vydavatele a inzerenty třetích stran.",
            linkedCategory: "marketing",
          },
          {
            title: "Více informací",
            description: `Další informace o tom, jak zpracováváme osobní údaje, naleznete v našich <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Zásady ochrany osobních údajů</a>.`,
          },
        ],
      },
    },
    sk: {
      consentModal: {
        title: "VÁŽIME SI VAŠE SÚKROMIE",
        description: `Sme odhodlaní vytvárať pre vás lepší digitálny zážitok. Používame nevyhnutné cookies, aby naša stránka fungovala hladko a poskytovala vám relevantné informácie. Prijatím cookies získate osobnejší zážitok prispôsobený vašim záujmom.`,
        acceptAllBtn: "PRIJAT VŠETKO",
        acceptNecessaryBtn: "ODMÍTAŤ",
        showPreferencesBtn: "Prispôsobiť",
      },
      preferencesModal: {
        title: "Nastavenia cookies",
        acceptAllBtn: "PRIJAT VŠETKO",
        acceptNecessaryBtn: "ODMÍTAŤ",
        savePreferencesBtn: "Uložiť nastavenia",
        closeIconLabel: "Zavrieť",
        sections: [
          {
            title: "Použitie cookies 📢",
            description: `Používame cookies na zabezpečenie základných funkcií webu a na zlepšenie vášho online zážitku. Pre každú kategóriu si môžete kedykoľvek zvoliť, či sa prihlásite alebo odhlásite, prostredníctvom odkazu trvalo umiestneného na stránke. Ďalšie podrobnosti o cookies nájdete v našom <a href="${cookiePolicyDocument}" target="_blank">Zásady používania cookies.</a>.`,
          },
          {
            title: "Nevyhnutné cookies",
            description:
              "Tieto cookies sú nevyhnutné pre správne fungovanie mojej stránky. Bez týchto cookies by stránka nefungovala správne.",
            linkedCategory: "nevyhnutné",
          },
          {
            title: "Analytické cookies",
            description:
              "Tieto cookies umožňujú stránke zapamätať si voľby, ktoré ste urobili v minulosti.",
            linkedCategory: "analytické",
          },
          {
            title: "Reklamné a marketingové cookies",
            description:
              "Marketingové cookies sa používajú na sledovanie návštevníkov stránky. Účelom je zobrazovať reklamy, ktoré sú pre konkrétneho používateľa relevantné a zaujímavé, a tým cennejšie pre vydavateľov a inzerentov tretích strán.",
            linkedCategory: "marketing",
          },
          {
            title: "Viac informácií",
            description: `Viac informácií o tom, ako spracovávame osobné údaje, nájdete v našich <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Zásady ochrany osobných údajov</a>.`,
          },
        ],
      },
    },
  }
}

function moveButtons(modalEl) {
  const secondGroup = modalEl.querySelector(
    '.cm__btn[data-role="show"]'
  ).parentNode
  const rejectButton = modalEl.querySelector('.cm__btn[data-role="necessary"]')
  secondGroup.insertBefore(rejectButton, secondGroup.firstChild)
}
